var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00b3ff;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,0C8.06,0,0,8.06,0,18s8.06,18,18,18,18-8.06,18-18S27.94,0,18,0h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.35,
    y: 8.87,
    width: 5.86,
    height: 2.36,
    rx: 1.18,
    ry: 1.18,
    transform: "translate(22.33 -2.23) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.79,
    y: 8.87,
    width: 5.86,
    height: 2.36,
    rx: 1.18,
    ry: 1.18,
    transform: "translate(33.77 -13.67) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.07,22.86c-.27,0-.54-.1-.75-.31l-2.9-2.9c-.41-.41-.41-1.08,0-1.5s1.08-.41,1.5,0l2.16,2.15,4.72-4.72c.41-.41,1.09-.41,1.5,0,.41,.41,.41,1.08,0,1.5l-5.47,5.47c-.21,.21-.48,.31-.75,.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.48,11.8v-3.25h-6.96v3.25s-.01,.08-.01,.13h6.98s-.01-.08-.01-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.96,8.56v3.25s-.01,.08-.01,.13c.99,0,1.79,.81,1.79,1.79v10.67c0,.99-.8,1.79-1.79,1.79H10.07c-.99,0-1.79-.8-1.79-1.79V13.73c0-.99,.8-1.79,1.79-1.79,0-.04-.01-.08-.01-.13v-3.25c-1.67,.01-3.03,1.37-3.03,3.05v12.79c0,1.68,1.37,3.05,3.05,3.05h15.87c1.68,0,3.05-1.37,3.05-3.05V11.61c0-1.67-1.36-3.04-3.03-3.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.2a9f842febd13f7f0140ea0967022174.svg";
export { ForwardRef as ReactComponent };